"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Star } from "lucide-react";

export function CompanyWatchButton({
  isin,
  ticker,
  slug,
  signedIn,
  initialWatched,
}: {
  isin: string;
  ticker: string;
  slug: string;
  signedIn: boolean;
  initialWatched: boolean;
}) {
  const router = useRouter();
  const [watched, setWatched] = useState(initialWatched);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  async function toggle() {
    if (!signedIn) {
      router.push(`/konto/logowanie?next=${encodeURIComponent(`/spolki/${slug}`)}`);
      return;
    }
    setPending(true);
    setError("");
    const response = await fetch("/api/watchlist", {
      method: watched ? "DELETE" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ isin }),
    });
    const data = await response.json().catch(() => ({})) as { error?: string; watched?: boolean };
    if (!response.ok) setError(data.error || "Nie udało się zmienić watchlisty.");
    else setWatched(Boolean(data.watched));
    setPending(false);
  }

  return (
    <div><button
      aria-pressed={watched}
      className={`inline-flex min-h-12 items-center justify-center gap-2 rounded-md border px-5 text-sm font-semibold transition ${
        watched
          ? "border-[#FFD700]/55 bg-[#FFD700]/10 text-[#FFD700]"
          : "border-[#3498db]/60 bg-[#3498db] text-[#07111d] hover:bg-[#54afe9]"
      }`}
      disabled={pending}
      onClick={toggle}
      type="button"
    >
      <Star aria-hidden="true" className={`size-4 ${watched ? "fill-current" : ""}`} />
      {pending ? "Zapisywanie..." : watched ? `Obserwujesz ${ticker}` : `Obserwuj ${ticker}`}
    </button>{error ? <p className="mt-3 text-sm text-red-200" role="status">{error}</p> : null}</div>
  );
}
